export default __webpack_public_path__ + "media/images/mailer-new/welcome-icons/share_step-off-0281044792c184c470a8545fa39f6c25.png";